<template>
  <div class="d-flex flex-wrap h-100">
    <div class="col-6 d-flex flex-column h-100">
      <b-overlay :show="!!editing" :opacity="0.95" blur="5px" variant="transparent" class="d-flex flex-column w-100 h-100">
        <template #overlay>
          <div class="text-center">
            <i class="far fa-edit fa-3x"></i>
          </div>
        </template>
        <div class="d-flex flex-wrap justify-content-end">
          <b-button variant="third" class="m-1" @click="onNew"><i class="fas fa-plus"></i></b-button>
          <b-button variant="third" class="m-1" @click="onLoad"><i class="fas fa-redo-alt"></i></b-button>
        </div>
        <ag-grid-vue id="pdrdebits-grid"
                    class="ag-theme-alpine w-100 h-100 d-flex flex-column flex-growl-1"
                    rowSelection="single"
                    :getLocaleText="localeTextFunc"
                    :gridOptions="debitsGridOptions"
                    :columnTypes="columnTypes"
                    :columnDefs="debitsColumnDefs"
                    :masterDetail="true"
                    :detailCellRendererParams="detailCellRendererParams"
                    :rowData="objList"
                    :getRowId="params => params.data.funcionarioID"
                    @firstDataRendered="onFirstDataRendered"
                    @gridReady="onGridReady"
                    @cellFocused="params => {
                      const node = params.api.rowModel.getRow(params.rowIndex)
                      node.setSelected(true)
                    }">
        </ag-grid-vue>
      </b-overlay>
    </div>
    <div v-if="editing" class="col-6 d-flex h-100">
      <b-card class="w-100 h-100 m-0 t-0">
        <template #header>
          <div class="d-flex">
            <div class="flex-grow-1"><i class="fas fa-edit text-thrid mr-1"></i><strong>{{ $lang.PCI.PdrDebits.Title }}</strong></div>
            <div class="card-actions">
              <b-link href="#" v-b-tooltip.hover :title="$lang.Common.Buttons.Save" @click="onSaveForm">
                <i class="fas fa-check" style="font-size:1rem;color:var(--success);"></i>
              </b-link>
              <b-link href="#" v-if="editing" v-b-tooltip.hover :title="$lang.Common.Buttons.Cancel" @click="onCancel">
                <i class="fas fa-times" style="font-size:1rem;color:var(--success);"></i>
              </b-link>
              <b-dropdown href="#"
                          v-if="objEdit.id"
                          variant="link"
                          class="h-100"
                          toggle-class="text-decoration-none p-0"
                          no-caret
                          tabindex="-1"
                          v-b-tooltip.hover
                          :title="$lang.Common.Tooltip.ButtonDelete">
                <template #button-content>
                  <i class="fa fa-trash text-danger p-1" style="cursor:pointer"></i>
                </template>
                <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
                <b-dropdown-item href="#" v-on:click="onDelete">{{$lang.Common.Yes}}</b-dropdown-item>
                <b-dropdown-item href="#">{{$lang.Common.No}}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </template>
        <div class="h-100 col-6">
          <b-form-group :label="'Cod. Obra'">
            <b-input v-model="objEdit.obra.referencia" @change="onSelectWork"></b-input>
            <span v-if="objEdit.obra">{{ objEdit.obra.idSite }}</span>
          </b-form-group>
          <b-form-group :label="'Funcionário'" v-if="objEdit.obra.id">
            <v-select v-model="objEdit.funcionarioID"
                      :getOptionLabel="param => `${param.nome} (${param.codigo})`"
                      :reduce="param => param.id"
                      :options="employees">
            </v-select>
          </b-form-group>
          <b-form-group :label="'Data'" v-if="objEdit.obra.id">
            <datepicker name="txtDate"
                        v-model="objEdit.data"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fas fa-times'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"/>
          </b-form-group>
          <b-form-group :label="'Valor'" v-if="objEdit.obra.id">
            <b-input type="number" v-model="objEdit.valor"></b-input>
          </b-form-group>
          <b-form-group :label="'Motivo'" v-if="objEdit.obra.id">
            <b-textarea rows="3" v-model="objEdit.motivo"></b-textarea>
          </b-form-group>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import gridMixin from '../mixins/gridMixin'
import PDRDebitsRepository from '@/shared/http/repositories/pci/pdrdebits'
import CompanyMixin from '@/store/module/company/mixin'
import actionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import { empty } from 'uuidv4'
import WorkRepository from '@/shared/http/repositories/business/work'

export default {
  name: 'PdrDebits',
  components: {
    AgGridVue
  },
  mixins: [gridMixin, CompanyMixin, actionsForm],
  data () {
    return {
      objList: [],
      objEdit: {},
      employees: [],
      editing: false,
      api: null,
      debitsApi: null,
      debitsGridOptions: {
        headerHeight: 40,
        rowHeight: 30,
        defaultColDef: {
          filter: 'agSetColumnFilter',
          resizable: true,
          editable: false,
          suppressMenu: false,
          sortable: true,
          menuTabs: ['filterMenuTab'],
          suppressMovable: true,
          lockVisible: true,
          minWidth: 30
        }
      },
      debitsColumnDefs: [
        { headerName: 'Funcionário', field: 'funcionario', width: 300, cellRenderer: 'agGroupCellRenderer' },
        { headerName: 'Débitos', field: 'debito', type: 'numberColumn' },
        { headerName: 'Descontos', field: 'desconto', type: 'numberColumn' }
      ],
      detailCellRendererParams: {
        detailGridOptions: {
          rowSelection: 'single',
          onCellDoubleClicked: this.onSelectRow,
          onFirstDataRendered: params => { params.api.sizeColumnsToFit() },
          getLocaleText: params => this.localeTextFunc(params),
          suppressHorizontalScroll: true,
          getRowId: params => params.data.id,
          columnDefs: [
            { headerName: 'Data', field: 'data', type: 'dateColumn' },
            { headerName: 'Obra', field: 'obra.referencia' },
            { headerName: 'Débito', field: 'valor', type: 'numberColumn' },
            { headerName: 'Motivo', field: 'motivo', type: 'memoColumn' }
          ],
          defaultColDef: {
            filter: 'agSetColumnFilter',
            resizable: true,
            editable: false,
            suppressMenu: false,
            sortable: true,
            menuTabs: ['filterMenuTab'],
            suppressMovable: true,
            lockVisible: true,
            minWidth: 30
          }
        },
        getDetailRowData: (params) => {
          loading.push()
          PDRDebitsRepository.GetDebits(params.data.funcionarioID)
            .then(response => {
              if (response.data.code > 0) {
                const obj = this.objList.filter(o => o.funcionarioID === params.data.funcionarioID)[0]
                obj.debitos = response.data.data
                params.successCallback(response.data.data)
              } else {
                throw new Error(response.data.message)
              }
            })
            .catch(err => this.onException(err))
            .finally(() => loading.close())
        }
      }
    }
  },
  methods: {
    onNew () {
      this.editing = 'insert'
      this.objEdit = {
        id: null,
        data: new Date(),
        obra: {}
      }
    },
    onLoad () {
      loading.push()
      PDRDebitsRepository.GetSummaryByEmployee(this.company.id)
        .then(response => {
          if (response.data.code > 0) {
            this.objList = response.data.data
          } else {
            throw new Error(response.data.message)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onSelectWork () {
      if (this.objEdit.obra.referencia) {
        loading.push()
        WorkRepository.GetWorkByRef({empresaId: this.company.id, referencia: this.objEdit.obra.referencia})
          .then(response => {
            if (response.data.code > 0 && response.data.data.length) {
              this.objEdit.obra = response.data.data[0]
              this.objEdit.obraID = this.objEdit.obra.id
              WorkRepository.GetTeam(this.objEdit.obraID)
                .then(response => {
                  if (response.data.code > 0) {
                    this.employees = response.data.data.filter(r => r.funcionarioId).map(r => r.funcionario)
                  }
                })
            } else {
              throw new Error(response.data.message)
            }
          })
          .catch(err => this.onException(err))
          .finally(() => loading.close())
      }
    },
    onDelete () {
      loading.push()
      PDRDebitsRepository.Delete(this.objEdit.id)
        .then(response => {
          if (response.data.code > 0) {
            const obj = this.objList.filter(o => o.funcionarioID === this.objEdit.funcionarioID)[0]
            const idx = obj.debitos.findIndex(o => o.id === this.objEdit.id)
            obj.debitos.splice(idx, 1)
            if (this.debitsApi) this.debitsApi.refreshCells()
            this.editing = false
            this.objEdit = {}
            this.employees = []
            this.onLoad()
          } else {
            throw new Error(response.data.message)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onSaveForm () {
      if (this.editing === 'insert') {
        this.objEdit.id = empty()
        this.onCreate()
      } else {
        this.onUpdate()
      }
    },
    onCreate () {
      loading.push()
      PDRDebitsRepository.Create(this.objEdit)
        .then(response => {
          if (response.data.code > 0) {
            this.editing = false
            this.objEdit = {}
            this.employees = []
            this.api.collapseAll()
            this.$nextTick(() => {
              this.api.refreshCells({force: true})
            })
            this.onLoad()
          } else {
            throw new Error(response.data.message)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onUpdate () {
      loading.push()
      PDRDebitsRepository.Update(this.objEdit)
        .then(response => {
          if (response.data.code > 0) {
            const rowIndex = this.api.getFocusedCell().rowIndex
            const rowNode = this.api.rowModel.getRow(rowIndex)
            const obj = rowNode.data
            const idx = obj.debitos.findIndex(o => o.id === this.objEdit.id)
            obj.debitos.splice(idx, 1, response.data.data)
            rowNode.setData(obj)
            this.debitsApi.refreshCells({force: true})
            this.editing = false
            this.objEdit = {}
            this.employees = []
            this.onLoad()
          } else {
            throw new Error(response.data.message)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onCancel () {
      this.editing = false
      this.objEdit = {}
    },
    onSelectRow (params) {
      this.debitsApi = params.api
      loading.push()
      WorkRepository.GetTeam(params.data.obraID)
        .then(response => {
          if (response.data.code > 0) {
            this.employees = response.data.data.filter(r => r.funcionarioId).map(r => r.funcionario)
            this.editing = 'edit'
            this.objEdit = params.data
          }
        })
        .finally(() => loading.close())
    },
    onGridReady (params) {
      this.api = params.api
      this.detailCellRendererParams.detailGridOptions.columnTypes = this.columnTypes
    },
    onFirstDataRendered (params) {
      setTimeout(() => {
        params.api.sizeColumnsToFit()
      }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/operational/pci/pdrdebits/pdrdebits.vue